import type { TrackingCookie } from '../types/tracking.js';
import { TRACKING_COOKIE_NAME, COOKIE_EXPIRY_DAYS, TRACKING_COOKIE_VERSION } from '../config.js';
import { getCookieRaw, setCookieRaw } from './cookie.js';
import { fitToCookieBudget } from './cookie-guard.js';

export function getTrackingData(): TrackingCookie {
  const raw = getCookieRaw(TRACKING_COOKIE_NAME);
  if (!raw) return { version: TRACKING_COOKIE_VERSION };
  try {
    const parsed: unknown = JSON.parse(raw);
    return parsed as TrackingCookie;
  } catch {
    return { version: TRACKING_COOKIE_VERSION };
  }
}

export function writeTrackingData(data: TrackingCookie): void {
  data.version = TRACKING_COOKIE_VERSION;
  setCookieRaw(TRACKING_COOKIE_NAME, fitToCookieBudget(data), COOKIE_EXPIRY_DAYS);
}

export function setTrackingField<K extends keyof TrackingCookie>(
  key: K,
  value: TrackingCookie[K],
): void {
  const data = getTrackingData();
  data[key] = value;
  writeTrackingData(data);
}
